<template>
  <div >
    <div>
      <div>视频列表</div>
      <li v-for="item in aaa" style="list-style-type:none;">
        <a v-if="item.type==='0'" :href="'http://'+item.filePath">{{item.filename}}</a>
      </li>
    </div>
    <div>
        <div>文件列表</div>
        <li v-for="item in aaa" style="list-style-type:none;">
          <a v-if="item.type==='1'" :href="'http://'+item.filePath">{{item.filename}}</a>
        </li>
      </div>
      <van-button plain type="primary" @click="toYanjiang">投稿</van-button>
  </div>
</template>

<script>

  export default {
  
    data() {
     return{
      userId : null,
      filePath:null,
      aaa:[]
     };
    },
    created() {
     this.userId = sessionStorage.getItem('userId');
     
  },
    methods: {
         getFileInfo:function(){
            var that = this;
            this.$axios.get(
      "http://ysj.fxiang.cn/upload/getFileInfo/",//根据openid获取用户信息
      {params:{
        userId: this.userId,
        }}
        ).then(function(resp){
          console.log(resp)
            that.aaa = resp.data
            resp.data.forEach(item =>{//遍历用户信息，得到需要的数据
            that.filePath = "http://"+item.filePath

            });
        },function(err){
            console.log("失败")
        })
         },
        toYanjiang:function(){
        this.$router.push({ path:'/ysj/yanjaing'  })
      }
},
 mounted () { 
    
      this.getFileInfo()
    }

  }
</script>